import { call, put, takeEvery } from "redux-saga/effects";
import { fetchTokenRequest, fetchTokenSuccess, fetchTokenFailure } from "../slice/guestAuthSlice";
import { guestLoginApi } from "../../api/apiService";

export function* fetchToken(): Generator<any, void, any> {
    try {
        // API call with no headers/body
        const response = yield call(guestLoginApi);

        const {
            message,
            token: { access, refresh },
        } = response.data;

        yield put(fetchTokenSuccess({ accessToken: access, refreshToken: refresh, message }));
    } catch (error: any) {
        yield put(fetchTokenFailure(error?.message || "An unknown error occurred."));
    }
}

export function* guestAuthSaga() {
    yield takeEvery(fetchTokenRequest, fetchToken);
}
